import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../primitives';

export const CreditLedgerSchema = oz.object({
  id: ObjectIdSchema,
  customerId: ObjectIdSchema,
  currentBalance: oz.number(),
}).openapi('CreditLedger');

export type CreditLedger = oz.infer<typeof CreditLedgerSchema>;
